import { CREATE_MUSEUM, DELETE_MUSEUM, DETAIL_LIST_MUSEUM, MUSEUM_DROPDOWN, MUSEUM_LIST,ACTIVE_MUSEUM } from "../api";
import axiosInstance from "../axiosInstance";




export const createMuseum = (props) => onResponse => {
    console.log(props);
    try {
        axiosInstance.post(CREATE_MUSEUM, props.values)
            .then((response) => {
                onResponse(response.data)
            })
            .catch((err) => {
                console.log(err);
                onResponse(err?.response?.data)
            });

    } catch (error) {

    }
};

export const deleteBranchDetails = (id) => onResponse => {
    try {

        axiosInstance.delete(DELETE_MUSEUM, { data: { id: id } })

            .then((response) => {
                onResponse(response.data);
            })
            .catch((err) => {
                onResponse(err?.response?.data);
            });

    } catch (error) {

    }

};

export const getMuseumDetails = (props) => onResponse => {
    console.log(props);
    try {
        axiosInstance.get(DETAIL_LIST_MUSEUM + '?id=' + props)
            .then((response) => {
                onResponse(response.data);
            })
            .catch((err) => {
                onResponse(err?.response?.data);
            });

    } catch (error) {

    }

};

export const getMuseumDropdown = (props) => onResponse => {
    try {



        let BASE_URL = MUSEUM_DROPDOWN + '?'
        if (props?.page) {
            BASE_URL += 'page=' + props?.page + '&'
        }
        if (props?.limit) {
            BASE_URL += 'limit=' + props?.limit + '&'
        }
        if (props?.search) {
            BASE_URL += 'search=' + props?.search + '&'
        }


        axiosInstance.get(BASE_URL)
            .then((response) => {
                onResponse(response.data);
            })
            .catch((err) => {
                onResponse(err?.response?.data);
            });

    } catch (error) {
        onResponse(error);
    }

};


export const listMuseum = (props) => onResponse => {
    console.log(props);

    try {
        let BASE_URL = MUSEUM_LIST + "?"
        if (props?.page) {
            BASE_URL += 'page=' + props?.page + '&'
        }
        if (props?.limit) {
            BASE_URL += 'limit=' + props?.limit + '&'
        }
        if (props?.search) {
            BASE_URL += 'search=' + props?.search + '&'
        }
        if (props?.sort_by) {
            BASE_URL += 'sort_by=' + props?.sort_by + '&'
        }
        if (props?.order) {
            BASE_URL += 'order=' + props?.order + '&'
        }
        if (props?.start_date) {
            BASE_URL += 'start_date=' + props?.start_date + '&'
        }
        if (props?.end_date) {
            BASE_URL += 'end_date=' + props?.end_date + '&'
        }
        if (props?.museum_type) {
            BASE_URL += 'museum_type=' + props?.museum_type + '&'
        }
        if (props?.is_active) {
            BASE_URL += 'is_active=' + props?.is_active + '&'
        }

        axiosInstance.get(BASE_URL)
            .then((response) => {
                onResponse(response.data)
            })
            .catch((err) => {
                onResponse(err?.response?.data)
            });


    } catch (error) {

    }
};

export const activeInactiveMuseum = (props) => onResponse => {
    try{
        axiosInstance.put(ACTIVE_MUSEUM ,{id:  props} )
            .then((response) => {
                onResponse(response.data);
            })
            .catch((err) => {
                onResponse(err?.response?.data);
            });

    }catch(error){
        
    }
}